import Tippy from "@tippyjs/react";

import { ITooltipWrapperProps } from "./module/constants";

import "tippy.js/dist/svg-arrow.css";
import "tippy.js/dist/tippy.css";

const TooltipWrapper = (props: ITooltipWrapperProps) => {
  const { content, children } = props;
  if (!content) {
    return children;
  }
  return (
    <Tippy delay={[1000, 0]} content={content} arrow={true}>
      {children}
    </Tippy>
  );
};

export default TooltipWrapper;
